<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        variant="info"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon
          icon="InfoIcon"
          size="15"
        />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5 class="mb-0 font-weight-bolder toastification-title text-info">
            {{ title }}
          </h5>
          <small class="d-inline-block text-body">
            {{ text }}
          </small>
          <div class="mt-50">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="openDownloads"
            >
              {{ actionLabel }}
            </b-button>
          </div>
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto"
          role="button"
          aria-label="Chiudi"
          @click="$emit('close-toast')"
        >
          <feather-icon
            icon="XIcon"
            class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BButton } from 'bootstrap-vue'

export default {
  name: 'BulkDownloadQueuedToast',
  components: {
    BAvatar,
    BButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    actionLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    openDownloads() {
      this.$emit('open-downloads')
      this.$emit('close-toast')
    },
  },
}
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
